<template>
  <Modal v-model="synchronizeWarehouseInventoryModal" :title="$t('key1007153')" width="750" class-name="commonModalStyles"
    :transfer="false" @on-visible-change="synchronizeWarehouseInventoryChange">
    <div class="flex align-items-center mb15">
      <h2 class="themeColor" style="flex: 6;">{{ $t('key1007154') }}</h2>
      <h2 class="themeColor" style="flex: 4;">{{ $t('key1007155') }}</h2>
    </div>
    <div class="flex align-items-center" v-for="item in ymsPlatformAccountWarehouseList">
      <p style="flex:6" class="mb10 flex align-items-center">
        <span class="font-weight-bold color-333 display-inline-block ellipsis_1 width_250" :title="item.warehouseName">{{ item.warehouseName }}</span>
        <span class="width_100 pl10">{{ $t('key1007156') }}</span>
      </p>
      <p style="flex:4" class="mb10">
        <Select v-model="item.ymsWarehouseId" transfer filterable clearable style="width: 250px;">
          <Option v-for="ele in productShippingWarehouseData" :value="ele.ymsWarehouseId" :label="ele.name + ' (' + ele.warehouseTypeName + ')'">
            <div class="flex align-items-center justify-content-between" style="width: 95%;">
              <span class="color-333">{{ ele.name }}</span>
              <span class="font-size-12 color-999">{{ ele.warehouseTypeName }}</span>
            </div>
          </Option>
        </Select>
      </p>
    </div>
    <template #footer>
      <Button @click="synchronizeWarehouseInventoryModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="ymsPlatformAccountWarehouseList.length <=0" @click="synchronizeWarehouseInventoryBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getBatchSupplierWarehouseData} from "@/utils/common";

export default {
  name: 'synchronizeWarehouseInventoryModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      synchronizeWarehouseInventoryModal: false,
      ymsPlatformAccountWarehouseList: [],
      ymsPlatformAccountId: null,
      productShippingWarehouseData: [],
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    async initSynchronizeWarehouseInventoryData(obj) {
      let {ymsPlatformAccountId} = obj;
      this.ymsPlatformAccountId = ymsPlatformAccountId;
      await getBatchSupplierWarehouseData([this.userInfo.merchantId]).then((newList) => {
        this.productShippingWarehouseData = this.uniqueFunc(newList, 'ymsWarehouseId');
      });
      this.ymsPlatformAccountWarehouseList = await this.getSynchronousWarehouseList();
      let warehouseByAccountIdList = await this.getQueryWarehouseByAccountId(ymsPlatformAccountId);
      if (warehouseByAccountIdList.length > 0) {
        this.ymsPlatformAccountWarehouseList.map((item) => {
          item.ymsWarehouseId = null;
          warehouseByAccountIdList.map((ele) => {
            if (item.warehouseId === ele.platformWarehouseId) {
              item.ymsWarehouseId = ele.warehouseId || null;
            }
          });
        });
      }
      this.synchronizeWarehouseInventoryModal = true;
    },
    // 获取同步库存到仓库的基础数据
    getSynchronousWarehouseList() {
      return new Promise((resolve) => {
        this.axios.get(api.get_ymsPlatformAccountWarehouse_warehouseQuery, {loading: true}).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.datas || [];
            resolve(data);
          }
        });
      });
    },
    // 获取已经设置同步仓库的id
    getQueryWarehouseByAccountId(ymsPlatformAccountId) {
      return new Promise((resolve) => {
        this.axios.get(api.get_ymsPlatformAccountWarehouse_queryWarehouseByAccountId + `${ymsPlatformAccountId}`).then((res) => {
          if (res.data.code === 0) {
            let data = res.data.datas || [];
            resolve(data);
          }
        });
      });
    },
    // 确定
    synchronizeWarehouseInventoryBtn() {
      let v = this;
      let queryList = [];
      if (v.ymsPlatformAccountWarehouseList.length > 0) {
        v.ymsPlatformAccountWarehouseList.map((item) => {
          if (item.ymsWarehouseId) {
            queryList.push({
              platformWarehouseId: item.warehouseId,
              platformWarehouseName: item.warehouseName,
              ymsPlatformAccountId: v.ymsPlatformAccountId,
              warehouseId: item.ymsWarehouseId
            });
          }
        });
        let newList = v.uniqueFunc(queryList, 'platformWarehouseId');
        v.axios.post(api.post_ymsPlatformAccountWarehouse_insertWarehouse, newList, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004700')}).then((res) => {
          if (res.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
            v.$emit('updateData', true);
            v.synchronizeWarehouseInventoryModal = false;
          }
        });
      }
    },
    // 监听弹窗
    synchronizeWarehouseInventoryChange(value) {
      if (!value) {
        this.ymsPlatformAccountWarehouseList = [];
        this.ymsPlatformAccountId = null;
        this.productShippingWarehouseData = [];
      }
    }
  }
};
</script>

<style lang="less">

</style>
